import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import Simulator from './components/Simulator';
import MarketData from './components/MarketData';
import HowItWorks from './components/HowItWorks';
import GovernmentLoans from './components/GovernmentLoans';
import ARMRates from './components/ARMRates';
import HELOCRates from './components/HELOCRates';
import LoanQualificationSimulator from './components/LoanQualificationSimulator';
import SlideOutNav from './components/SlideOutNav';

function App() {
  const [currentPage, setCurrentPage] = useState('landing');

  const navigateToSimulator = () => {
    setCurrentPage('simulator');
  };

  const navigateToLanding = () => {
    setCurrentPage('landing');
  };

  const navigateToMarketData = () => {
    setCurrentPage('marketdata');
  };

  const navigateToHowItWorks = () => {
    setCurrentPage('howitworks');
  };

  const navigateBackToSimulator = () => {
    setCurrentPage('simulator');
  };

  const navigateToGovernmentLoans = () => {
    setCurrentPage('governmentloans');
  };

  const navigateToARMRates = () => {
    setCurrentPage('armrates');
  };

  const navigateToHELOC = () => {
    setCurrentPage('helocrates');
  };

  const navigateToLoanQualification = () => {
    setCurrentPage('loanqualification');
  };

  const navigateToPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen">
      {/* Slide-out Navigation */}
      <SlideOutNav 
        currentPage={currentPage} 
        onNavigate={navigateToPage}
      />
      
      {currentPage === 'landing' && (
        <LandingPage 
          forecastData={null}
          aiSummary={null}
          loading={false}
          onLaunchSimulator={navigateToSimulator}
          onViewHowItWorks={navigateToHowItWorks}
          onViewGovernmentLoans={navigateToGovernmentLoans}
          onViewARMRates={navigateToARMRates}
          onViewHELOC={navigateToHELOC}
          onViewLoanQualification={navigateToLoanQualification}
        />
      )}
      {currentPage === 'simulator' && (
        <Simulator 
          onBackToLanding={navigateToLanding}
          onViewMarketData={navigateToMarketData}
        />
      )}
      {currentPage === 'marketdata' && (
        <MarketData onBackToSimulator={() => setCurrentPage('simulator')} />
      )}
      {currentPage === 'howitworks' && (
        <HowItWorks onBackToHome={navigateToLanding} />
      )}
      {currentPage === 'governmentloans' && (
        <GovernmentLoans onBackToHome={navigateToLanding} />
      )}
      {currentPage === 'armrates' && (
        <ARMRates onBackToHome={navigateToLanding} />
      )}
      {currentPage === 'helocrates' && (
        <HELOCRates onBackToHome={navigateToLanding} />
      )}
      {currentPage === 'loanqualification' && (
        <LoanQualificationSimulator onBackToHome={navigateToLanding} />
      )}
    </div>
  );
}

export default App;
